const pt: Record<string, string> = {}
const en: Record<string, string> = {}
const es: Record<string, string> = {}

const add = (source: string, english: string, spanish: string) => {
  const key = `declarative.${source}`
  pt[key] = source
  en[key] = english
  es[key] = spanish
}

// Campos, colunas e filtros compartilhados pelos cadastros declarativos.
;[
  ['Acesso', 'Access', 'Acceso'],
  ['Ano', 'Year', 'Año'],
  ['Ativa', 'Active', 'Activa'],
  ['Ativo', 'Active', 'Activo'],
  ['Inativa', 'Inactive', 'Inactiva'],
  ['Inativo', 'Inactive', 'Inactivo'],
  ['Bairro', 'District', 'Barrio'],
  ['Bloqueado', 'Blocked', 'Bloqueado'],
  ['CEP', 'Postal code', 'Código postal'],
  ['CNH', "Driver's license", 'Licencia de conducir'],
  ['CNPJ', 'Tax ID', 'CNPJ'],
  ['Capacidade (t)', 'Capacity (t)', 'Capacidad (t)'],
  ['Carreta 1', 'Trailer 1', 'Remolque 1'],
  ['Carreta 2, opcional', 'Trailer 2, optional', 'Remolque 2, opcional'],
  ['Carretas', 'Trailers', 'Remolques'],
  ['Categoria', 'Category', 'Categoría'],
  ['Categoria CNH', 'License category', 'Categoría de licencia'],
  ['Cavalo', 'Truck tractor', 'Cabeza tractora'],
  ['Cliente', 'Customer', 'Cliente'],
  ['Cliente (dono)', 'Customer (owner)', 'Cliente (propietario)'],
  ['Clientes', 'Customers', 'Clientes'],
  ['Clientes no escopo', 'Customers in scope', 'Clientes en el alcance'],
  ['Código', 'Code', 'Código'],
  ['Conjunto', 'Set', 'Conjunto'],
  ['Contexto', 'Context', 'Contexto'],
  ['Documento', 'Document', 'Documento'],
  ['Documento (CPF)', 'Document (CPF)', 'Documento (CPF)'],
  ['E-mail', 'Email', 'Correo electrónico'],
  ['Em folga', 'On leave', 'De descanso'],
  ['Endereço', 'Address', 'Dirección'],
  ['Contato', 'Contact', 'Contacto'],
  ['Observações gerais', 'General notes', 'Observaciones generales'],
  ['Forma padrão de cobrança da hospedagem', 'Default lodging billing mode', 'Forma estándar de cobro del hospedaje'],
  ['Observações comerciais da cobrança', 'Commercial billing notes', 'Notas comerciales del cobro'],
  ['Semanal', 'Weekly', 'Semanal'],
  ['Quinzenal', 'Biweekly', 'Quincenal'],
  ['Mensal', 'Monthly', 'Mensual'],
  ['No final da hospedagem', 'At the end of the stay', 'Al final del hospedaje'],
  ['Data de fechamento, vencimento, proporcionalidade em saída antecipada e outras regras negociadas', 'Closing date, due date, proportional early check-out and other negotiated rules', 'Fecha de cierre, vencimiento, proporcionalidad por salida anticipada y otras reglas negociadas'],
  ['A forma de cobrança é copiada para cada novo registro de hospedagem na criação. Registros existentes não mudam.', 'The billing mode is copied into each new lodging record at creation. Existing records do not change.', 'La forma de cobro se copia en cada registro de hospedaje nuevo al crearlo. Los registros existentes no cambian.'],
  ['Equipe', 'Team', 'Equipo'],
  ['Filial', 'Branch', 'Sucursal'],
  ['Forma da cerca', 'Geofence shape', 'Forma de la geocerca'],
  ['Frotas', 'Fleet', 'Flota'],
  ['Frotas avulsas', 'Standalone fleet items', 'Vehículos independientes'],
  ['Local', 'Location', 'Lugar'],
  ['Logradouro', 'Street', 'Calle'],
  ['Mapa', 'Map', 'Mapa'],
  ['Marca', 'Brand', 'Marca'],
  ['Matrícula', 'Registration', 'Matrícula'],
  ['Membros', 'Members', 'Miembros'],
  ['Membros da dupla (backoffice)', 'Pair members (back office)', 'Miembros de la dupla (backoffice)'],
  ['Modelo', 'Model', 'Modelo'],
  ['Motorista', 'Driver', 'Conductor'],
  ['Município', 'City', 'Municipio'],
  ['Município/UF', 'City/State', 'Municipio/Estado'],
  ['Máquina', 'Machine', 'Máquina'],
  ['Nome', 'Name', 'Nombre'],
  ['Nome da dupla', 'Pair name', 'Nombre de la dupla'],
  ['Nome fantasia', 'Trade name', 'Nombre comercial'],
  ['Nome (auto: MOTORISTA | PLACA se vazio)', 'Name (auto: DRIVER | PLATE when empty)', 'Nombre (auto: CONDUCTOR | MATRÍCULA si está vacío)'],
  ['Nome (auto: OPERADOR | IDENT. se vazio)', 'Name (auto: OPERATOR | ID when empty)', 'Nombre (auto: OPERADOR | ID si está vacío)'],
  ['Número', 'Number', 'Número'],
  ['Observações', 'Notes', 'Observaciones'],
  ['Operador', 'Operator', 'Operador'],
  ['Ordem', 'Order', 'Orden'],
  ['Papel', 'Role', 'Rol'],
  ['Pendente', 'Pending', 'Pendiente'],
  ['Pessoal', 'Personnel', 'Personal'],
  ['Pessoal avulso', 'Standalone personnel', 'Personal independiente'],
  ['Pivôs', 'Fields', 'Pivotes'],
  ['Placa', 'Plate', 'Matrícula'],
  ['Produto', 'Product', 'Producto'],
  ['Proprietário', 'Owner', 'Propietario'],
  ['Quilos', 'Kilograms', 'Kilogramos'],
  ['Raio da cerca em km', 'Geofence radius in km', 'Radio de la geocerca en km'],
  ['Razão social', 'Legal name', 'Razón social'],
  ['RENAVAM', 'Vehicle registry', 'Registro vehicular'],
  ['Rótulo', 'Label', 'Etiqueta'],
  ['Rótulo (en)', 'Label (en)', 'Etiqueta (en)'],
  ['Rótulo (pt)', 'Label (pt)', 'Etiqueta (pt)'],
  ['Sacas', 'Bags', 'Sacos'],
  ['Sim', 'Yes', 'Sí'],
  ['Não', 'No', 'No'],
  ['Situação', 'Status', 'Situación'],
  ['Telefone', 'Phone', 'Teléfono'],
  ['Tipo', 'Type', 'Tipo'],
  ['Tipo do veículo', 'Vehicle type', 'Tipo de vehículo'],
  ['Toneladas', 'Tons', 'Toneladas'],
  ['Transportadora', 'Carrier', 'Transportista'],
  ['UF', 'State', 'Estado'],
  ['Unidade', 'Unit', 'Unidad'],
  ['Validade CNH', 'License expiration', 'Vencimiento de la licencia'],
  ['Vínculo', 'Employment type', 'Vínculo'],
  ['Área', 'Area', 'Área'],
  ['Autônomo', 'Freelancer', 'Autónomo'],
  ['Frota', 'Fleet', 'Flota'],
  ['Manutenção', 'Maintenance', 'Mantenimiento'],
  ['Círculo por ponto e raio', 'Circle by center and radius', 'Círculo por punto y radio'],
  ['Polígono desenhado no mapa', 'Polygon drawn on the map', 'Polígono dibujado en el mapa'],
  ['— Sem dono (global) —', '— No owner (global) —', '— Sin propietario (global) —'],
  ['Todas', 'All', 'Todas'],
  ['Todos', 'All', 'Todos'],
  ['Equipe do backoffice', 'Back-office team', 'Equipo de backoffice'],
  ['Filtrar por categoria', 'Filter by category', 'Filtrar por categoría'],
  ['Filtrar por contexto', 'Filter by context', 'Filtrar por contexto'],
  ['Filtrar por tipo', 'Filter by type', 'Filtrar por tipo'],
  ['Administrador (equipe)', 'Administrator (team)', 'Administrador (equipo)'],
  ['Operador (equipe)', 'Operator (team)', 'Operador (equipo)'],
  ['Administrador (cliente)', 'Administrator (customer)', 'Administrador (cliente)'],
  ['Operador (cliente)', 'Operator (customer)', 'Operador (cliente)'],
  ['Sem cavalo', 'No truck tractor', 'Sin cabeza tractora'],
  ['Sem disponibilidade registrada', 'No availability recorded', 'Sin disponibilidad registrada'],
  ['Já escalado', 'Already scheduled', 'Ya programado'],
  ['Em trânsito', 'In transit', 'En tránsito'],
  ['Descarregando', 'Unloading', 'Descargando'],
  ['Em manutenção', 'Under maintenance', 'En mantenimiento'],
  ['Em outra programação', 'In another schedule', 'En otra programación'],
  ['Em operação', 'In operation', 'En operación'],
  ['Afastado', 'Away', 'Ausente'],
].forEach(([source, english, spanish]) => add(source, english, spanish))

// Busca, ajuda e validação.
;[
  ['Buscar cliente…', 'Search customer…', 'Buscar cliente…'],
  ['Buscar frota (placa/código)…', 'Search fleet (plate/code)…', 'Buscar flota (matrícula/código)…'],
  ['Buscar motorista…', 'Search driver…', 'Buscar conductor…'],
  ['Buscar máquina…', 'Search machine…', 'Buscar máquina…'],
  ['Buscar operador…', 'Search operator…', 'Buscar operador…'],
  ['Buscar pessoa…', 'Search person…', 'Buscar persona…'],
  ['Buscar placa da carreta…', 'Search trailer plate…', 'Buscar matrícula del remolque…'],
  ['Buscar placa do cavalo…', 'Search truck plate…', 'Buscar matrícula de la cabeza tractora…'],
  ['Buscar usuário do backoffice…', 'Search back-office user…', 'Buscar usuario de backoffice…'],
  ['Padrão 1 km', 'Default 1 km', 'Predeterminado 1 km'],
  ['Soja, milho…', 'Soybeans, corn…', 'Soja, maíz…'],
  ['Selecione a categoria', 'Select a category', 'Seleccione una categoría'],
  ['Selecione o tipo do veículo', 'Select the vehicle type', 'Seleccione el tipo de vehículo'],
  ['Informe a razão social', 'Enter the legal name', 'Ingrese la razón social'],
  ['Informe o nome', 'Enter the name', 'Ingrese el nombre'],
  ['Informe o código', 'Enter the code', 'Ingrese el código'],
  ['Informe o rótulo', 'Enter the label', 'Ingrese la etiqueta'],
  ['Informe o contexto', 'Enter the context', 'Ingrese el contexto'],
  ['Informe o rótulo (pt)', 'Enter the Portuguese label', 'Ingrese la etiqueta en portugués'],
  ['Informe o rótulo (en)', 'Enter the English label', 'Ingrese la etiqueta en inglés'],
  ['E-mail inválido', 'Invalid email', 'Correo electrónico no válido'],
  ['O e-mail não pode ser alterado.', 'The email cannot be changed.', 'El correo electrónico no se puede cambiar.'],
  ['Enviaremos um e-mail de ativação.', 'We will send an activation email.', 'Enviaremos un correo de activación.'],
  ['Latitude deve estar entre -90 e 90', 'Latitude must be between -90 and 90', 'La latitud debe estar entre -90 y 90'],
  ['Longitude deve estar entre -180 e 180', 'Longitude must be between -180 and 180', 'La longitud debe estar entre -180 y 180'],
  ['Raio deve ser maior que 0 e no máximo 50', 'Radius must be greater than 0 and at most 50', 'El radio debe ser mayor que 0 y como máximo 50'],
  ['Desenhe a cerca no mapa (mínimo 3 pontos)', 'Draw the geofence on the map (at least 3 points)', 'Dibuje la geocerca en el mapa (mínimo 3 puntos)'],
  ['Informe latitude e longitude juntas', 'Enter latitude and longitude together', 'Ingrese latitud y longitud juntas'],
  ['Latitude e longitude não podem ser ambas 0', 'Latitude and longitude cannot both be 0', 'La latitud y la longitud no pueden ser ambas 0'],
  ['Selecione o cliente', 'Select a customer', 'Seleccione un cliente'],
].forEach(([source, english, spanish]) => add(source, english, spanish))

// Títulos, subtítulos e nomes singulares.
;[
  ['Cadastros', 'Records', 'Registros'],
  ['Categorias', 'Categories', 'Categorías'],
  ['Conjuntos', 'Sets', 'Conjuntos'],
  ['Portal', 'Portal', 'Portal'],
  ['Clientes', 'Customers', 'Clientes'],
  ['cliente', 'customer', 'cliente'],
  ['Locais', 'Locations', 'Lugares'],
  ['local', 'location', 'lugar'],
  ['Frota', 'Fleet', 'Flota'],
  ['item de frota', 'fleet item', 'elemento de flota'],
  ['Pessoas', 'Personnel', 'Personas'],
  ['pessoa', 'person', 'persona'],
  ['Produtos', 'Products', 'Productos'],
  ['produto', 'product', 'producto'],
  ['Usuários', 'Users', 'Usuarios'],
  ['usuário', 'user', 'usuario'],
  ['Cargos', 'Positions', 'Cargos'],
  ['cargo', 'position', 'cargo'],
  ['Cargo', 'Position', 'Cargo'],
  ['Permissões', 'Permissions', 'Permisos'],
  ['Áreas', 'Areas', 'Áreas'],
  ['Todo usuário deste cargo recebe estas permissões. Mudar aqui muda todos eles de uma vez.',
    'Every user in this position gets these permissions. Changing them here changes all of them at once.',
    'Todo usuario de este cargo recibe estos permisos. Cambiarlos aquí los cambia a todos de una vez.'],
  ['Duplas', 'Pairs', 'Duplas'],
  ['Dupla', 'Pair', 'Dupla'],
  ['Caminhões', 'Trucks', 'Camiones'],
  ['Caminhões 2 Reboques', 'Trucks with 2 trailers', 'Camiones con 2 remolques'],
  ['Maquinários', 'Machinery', 'Maquinaria'],
  ['Status', 'Statuses', 'Estados'],
  ['status', 'status', 'estado'],
  ['Tipos de veículo', 'Vehicle types', 'Tipos de vehículo'],
  ['tipo de veículo', 'vehicle type', 'tipo de vehículo'],
  ['Categorias de pessoas', 'Personnel categories', 'Categorías de personas'],
  ['categoria de pessoa', 'personnel category', 'categoría de persona'],
  ['Categorias de locais', 'Location categories', 'Categorías de lugares'],
  ['categoria de local', 'location category', 'categoría de lugar'],
  ['Categorias de produtos', 'Product categories', 'Categorías de productos'],
  ['categoria de produto', 'product category', 'categoría de producto'],
  ['Modalidades', 'Modalities', 'Modalidades'],
  ['modalidade', 'modality', 'modalidad'],
  ['Empresas contratantes (tenants) — ex.: Helix, Limagrain.', 'Contracting companies (tenants) — e.g. Helix, Limagrain.', 'Empresas contratantes (tenants), p. ej. Helix, Limagrain.'],
  ['Fazendas, sedes e unidades (origens e destinos).', 'Farms, headquarters and facilities (origins and destinations).', 'Fincas, sedes y unidades (orígenes y destinos).'],
  ['Modalidades da Frota informadas pelo Protheus.', 'Fleet modalities provided by Protheus.', 'Modalidades de la flota informadas por Protheus.'],
  ['Motoristas, operadores e produtores.', 'Drivers, operators and growers.', 'Conductores, operadores y productores.'],
  ['Catálogo de grãos e insumos (produto rural).', 'Grain and input catalog (agricultural product).', 'Catálogo de granos e insumos (producto agrícola).'],
  ['Equipe do backoffice e usuários dos clientes. Criar envia e-mail de ativação.', 'Back-office team and customer users. Creating one sends an activation email.', 'Equipo de backoffice y usuarios de clientes. Al crear se envía un correo de activación.'],
  ['Os operadores da sua empresa. Criar envia um e-mail de ativação.', 'Your company operators. Creating one sends an activation email.', 'Los operadores de su empresa. Al crear se envía un correo de activación.'],
  ['Pares de backoffice que delimitam o escopo operacional (clientes, frota, pessoal, membros).', 'Back-office pairs that define the operational scope (customers, fleet, personnel and members).', 'Duplas de backoffice que delimitan el alcance operativo (clientes, flota, personal y miembros).'],
  ['Motorista + cavalo + carreta(s). Um recurso (motorista/cavalo/carreta) só pode estar em um conjunto.', 'Driver + truck tractor + trailer(s). A resource can belong to only one set.', 'Conductor + cabeza tractora + remolque(s). Un recurso solo puede pertenecer a un conjunto.'],
  ['Operador + máquina. Um operador/máquina não pode estar em dois conjuntos ativos.', 'Operator + machine. An operator or machine cannot be in two active sets.', 'Operador + máquina. Un operador o máquina no puede estar en dos conjuntos activos.'],
  ['Estados universais do domínio (tickets, cargas…). Código em inglês, rótulos pt/en.', 'Universal domain statuses (tickets, loads…). English code, PT/EN labels.', 'Estados universales del dominio (solicitudes, cargas…). Código en inglés, etiquetas PT/EN.'],
  ['Modalidades do Protheus, Plataforma e Outros. A modalidade define a categoria da placa.', 'Protheus modalities, Platform and Other. The modality defines the plate category.', 'Modalidades de Protheus, Plataforma y Otros. La modalidad define la categoría de la matrícula.'],
  ['Motorista, operador, produtor…', 'Driver, operator, grower…', 'Conductor, operador, productor…'],
  ['Fazenda, sede, unidade de descarga…', 'Farm, headquarters, unloading facility…', 'Finca, sede, unidad de descarga…'],
  ['Grão, insumo…', 'Grain, input…', 'Grano, insumo…'],
  ['Colheita e Transporte, Colheita, Transporte, Movimentação de Máquina', 'Harvest and Transport, Harvest, Transport, Machine Movement', 'Cosecha y Transporte, Cosecha, Transporte, Movimiento de Máquina'],
  ['Permissões de acesso', 'Access permissions', 'Permisos de acceso'],
  ['Marque o que este usuário pode ver e fazer em cada área.', 'Choose what this user can view and do in each area.', 'Seleccione lo que este usuario puede ver y hacer en cada área.'],
  ['Marque o que este usuário pode ver e fazer.', 'Choose what this user can view and do.', 'Seleccione lo que este usuario puede ver y hacer.'],
  ['Ao vincular um cliente, seus contratos, frotas e pessoal entram no escopo da dupla automaticamente (por cliente). As abas Frotas e Pessoal servem para itens avulsos.', 'When a customer is linked, their contracts, fleet and personnel enter the pair scope automatically. The Fleet and Personnel tabs are for standalone items.', 'Al vincular un cliente, sus contratos, flota y personal entran automáticamente en el alcance de la dupla. Las pestañas Flota y Personal son para elementos independientes.'],
  ['Desenhe a cerca no mapa abaixo. O centro é calculado sozinho.', 'Draw the geofence on the map below. Its center is calculated automatically.', 'Dibuje la geocerca en el mapa de abajo. El centro se calcula automáticamente.'],
  ['Cerca no mapa', 'Geofence on map', 'Geocerca en el mapa'],
  ['Localização no mapa', 'Location on map', 'Ubicación en el mapa'],
  ['Novo local', 'New location', 'Nuevo lugar'],
  ['Desenhe o polígono da cerca com o botão de polígono e clique no mapa.', 'Use the polygon tool and click the map to draw the geofence.', 'Use la herramienta de polígono y haga clic en el mapa para dibujar la geocerca.'],
  ['Clique no mapa para marcar a posição, ou arraste o marcador.', 'Click the map to mark the position, or drag the marker.', 'Haga clic en el mapa para marcar la posición o arrastre el marcador.'],
  ['Abrir no Google Maps', 'Open in Google Maps', 'Abrir en Google Maps'],
  ['Limpar cerca', 'Clear geofence', 'Limpiar geocerca'],
  ['Limpar posição', 'Clear position', 'Limpiar posición'],
  ['Ver no mapa', 'View on map', 'Ver en el mapa'],
  ['Fechar', 'Close', 'Cerrar'],
  ['Latitude', 'Latitude', 'Latitud'],
  ['Longitude', 'Longitude', 'Longitud'],
  ['Latitude do centro', 'Center latitude', 'Latitud del centro'],
  ['Longitude do centro', 'Center longitude', 'Longitud del centro'],
].forEach(([source, english, spanish]) => add(source, english, spanish))

// Rótulos que o SERVIDOR manda prontos, em português, e que a tela só exibe: as
// situações do contrato na faixa de indicadores da grade de Contratos. Traduzir na
// origem obrigaria o backend a saber o idioma de quem pediu; aqui a faixa acompanha
// a tela, e o código continua sendo a chave que o filtro usa.
;[
  ['Previsto', 'Planned', 'Previsto'],
  ['Aguardando liberação', 'Awaiting release', 'Esperando liberación'],
  ['Em andamento', 'In progress', 'En curso'],
  ['Paralisado', 'Halted', 'Paralizado'],
  ['Finalizado', 'Completed', 'Finalizado'],
  ['Finalizado com pendência', 'Completed with a pending issue', 'Finalizado con un pendiente'],
].forEach(([source, english, spanish]) => add(source, english, spanish))

export default { pt, en, es }
